import { isStripeFeatureActive } from './stripeFeature';

/**
 * Whether email/calendar integration UI should be shown.
 *
 * When Stripe is hidden for the user (global or company flag), hide entirely.
 * Kjuup+ with no company Kjuup.io booking: hide those sections entirely.
 * After company trial ended: only company admins with a seat see the note UI
 * (`showCompanyTrialEndedNote` from subscription status).
 */
export function canShowEmailCalendarIntegration({
  isKjuupPlusMember,
  hasActiveKjuupIoPlan,
  showCompanyTrialEndedNote = false,
  stripeFeatureEnabled,
  companyStripeFeatureEnabled,
}) {
  const stripeUiEnabled = isStripeFeatureActive({
    stripeFeatureEnabled,
    companyStripeFeatureEnabled,
    isKjuupPlusMember,
  });
  if (!stripeUiEnabled) {
    return false;
  }
  if (isKjuupPlusMember && !hasActiveKjuupIoPlan) {
    return !!showCompanyTrialEndedNote;
  }
  return true;
}
